import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ChangePasswordParams, User } from '~core/models/auth.models';
import { addUserComputedProperties } from '~core/utils/auth';
import { Attachment } from '~core/models/attachment.models';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { UserPreferences } from '~core/models/core.models';

@Injectable()
export class ProfileService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  read(): Observable<User> {
    return this._httpClient
      .get<User>(this._apiConstantsService.profileUrl)
      .pipe(map(res => addUserComputedProperties(res)));
  }

  patch(options: Partial<User>): Observable<User> {
    return this._httpClient
      .patch<User>(this._apiConstantsService.profileUrl, options)
      .pipe(map(res => addUserComputedProperties(res)));
  }

  changePassword(data: ChangePasswordParams): Observable<void> {
    return this._httpClient.put<void>(
      `${this._apiConstantsService.profileUrl}/change/password`,
      data
    );
  }

  uploadAvatar(file: File | string): Observable<Attachment> {
    const formData = new FormData();
    formData.append('file', file);
    return this._httpClient.post<Attachment>(
      `${this._apiConstantsService.profileUrl}/avatars`,
      formData
    );
  }

  readPreference(): Observable<UserPreferences> {
    return this._httpClient
      .get<{
        preference: UserPreferences;
      }>(this._apiConstantsService.preferencesUrl)
      .pipe(map(res => res.preference));
  }

  setPreference(preferences: Partial<UserPreferences>): Observable<unknown> {
    return this._httpClient.patch(this._apiConstantsService.preferencesUrl, {
      preference: preferences
    });
  }
}
